import { create } from 'zustand';
import { setWorkspaceCookies } from '../cookies/workspace.cookies';
import { IWorkspace, IWorkspaceStore } from '../interfaces/workspace.interface';
import { getWorkspaces, createWorkspace } from '../api/workspace';
import { connectSocket } from '../sockets/socket.config';

export const useWorkspaceStore = create<IWorkspaceStore>((set) => ({
    data: null,
    loading: false,
    error: null,
    setLoading: (loading: boolean) => set({ loading }),
    setError: (error: string | null) => set({ error }),
    setData: (data: IWorkspace | null) => set({ data }),
}));

export const startLoadWorkspace = async () => {
    try {
        useWorkspaceStore.setState(() => ({ loading: true }));
        const response: any = await getWorkspaces();
        const { data: body } = response;
        if (body.length > 0) {
            const workspaceID = body[0]._id;
            setWorkspaceCookies({ workspaceID });
            connectSocket(workspaceID);
            useWorkspaceStore.setState(() => ({ data: body[0], loading: false }));
        } else {
            useWorkspaceStore.setState(() => ({ loading: false }));
        }
    } catch (error: any) {
        console.error('[startLoadWorkspace] Error', error);
        useWorkspaceStore.setState(() => ({ loading: false, error: error.message }));
    }
};

export const startCreateWorkspace = async (values: any) => {
    try {
        useWorkspaceStore.setState(() => ({ loading: true }));
        const { data }: any = await createWorkspace(values);
        useWorkspaceStore.setState(() => ({ data, loading: false }));
        setWorkspaceCookies({
            workspaceID: data._id,
        });
    } catch (error: any) {
        console.error('[startCreateWorkspace] Error', error);
        useWorkspaceStore.setState(() => ({ loading: false, error: error.message }));
    }
};

export const startUpdateWorkspace = async (data: Partial<IWorkspace>) => {
    try {
        useWorkspaceStore.setState(() => ({ loading: true }));
        useWorkspaceStore.setState((state) => ({ data: { ...state.data, ...data } as IWorkspace, loading: false }));
    } catch (error: any) {
        console.error('[startUpdateWorkspace] Error', error);
        useWorkspaceStore.setState(() => ({ loading: false, error: error.message }));
    }
};
